export default __webpack_public_path__ + "spider_giant_transparent.png?ea6114475b74e7ebee371956de651900";